<template>
  <div class="go-in">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="section-summary">
          <div class="container">
            <div class="main">
              <div class="title">商品比价API使用说明</div>
              <div class="kuangcontent">
                <div class="divapims">
                  <h2>比价搜索接口，通过关键词进行全网比价</h2>
                </div>
                <div class="divsm">
                  <div>
                    全网商品搜索需要采集、数据分析、搜索开发、算法等团队的配合，企业如果自建的话一方面成本高企，另一方面效果也很难保障，跟我们的合作优势：
                    <br />
                    1）通过关键词搜到全网商品；
                    <br />
                    2）灵活入参：关键词、商城、分类、品牌、价格区间、价格或销量排序等；
                    <br />
                    3）返回优惠叠加计算后的到手价；
                    <br />
                    4）可根据你的需求定制价格更新频率，最快可达到小时级；
                    <br />
                    5）本接口适合有开发能力的团队。如何没有开发能力，建议使用价格监测系统
                    <br />
                    <br />
                    接口调用方式和参数说明>>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    this.loading = false
    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         this.honorList = responseHonor.data;
    //         this.partnerImg = responseEnterprise.data;
    //         this.teamItem = responseTeam.data;

    //         var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         window.console.log(groupCount);
    //         for (let i = 0; i < groupCount; i++) {
    //           let img2 = [];
    //           for (let j = 0; j < 2; j++) {
    //             if (responseCourse.data.length - 1 >= i * 2 + j) {
    //               img2.push(responseCourse.data[i * 2 + j]);
    //             }
    //           }
    //           this.courseList.push(img2);
    //         }
    //         window.console.log(this.courseList);
    //         this.loading = false;
    //       }
    //     )
    //   );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  background-color: #eee;

  .section {
    width: 100%;
    background-color: #eee;

    &-content {
      width: 994px;
      margin: 0 auto;
      background-color: #fff;
      // background-color: #eee;

      .section-summary {
        margin-top: 20px;

        .container {
          width: 968px;
          margin: 0px auto;
          text-align: center;
          // min-height: 1150px;

          .main {
            // border: 1px solid #eee;
            width: 968px;
            // background-color: #fff;
            margin: 30px 0px;
            padding: 20px 0;

            .title {
              margin-left: 30px;
              margin-top: 30px;
              font-size: 22px;
              font-weight: bold;
              text-align: left;
              color: #000;
            }

            .kuangcontent {
              margin: 40px;
              font-size: 14px;
              line-height: 30px;
              text-align: left;
              color: #333333;

              .divapims {
                margin-top: 30px;
                margin-bottom: 20px;
                font-size: 14px;
              }

              .divsm {
                color: #333;
                font-size: 14px;

                div {
                  font-size: 14px;
                  line-height: 30px;
                }
              }

              .box {
                float: left;
                width: 260px;
                height: 160px;
                border: 1px solid #eee;
                padding: 10px;
                margin-right: 10px;
                margin-bottom: 10px;
                font-size: 14px;
              }
            }


          }
        }
      }

      // .content-summary {
      //   //height: 500px;
      //   display: flex;
      //   justify-content: space-around;
      //   padding: 100px 0;
      //   .summary-left {
      //     width: 600px;
      //     .title {
      //       font-size: 25px;
      //       color: #e13834;
      //     }
      //     .eTitle {
      //       font-size: 17px;
      //       color: #e13834;
      //       padding: 20px 0;
      //     }
      //     .content {
      //       color: #14679f;
      //       font-size: 14px;
      //       text-indent: 25px;
      //       line-height: 30px;
      //     }
      //   }

      //   .summary-right {
      //     width: 400px;
      //     height: 310px;
      //     border: 2px solid #1d42b9;
      //     //animation: imgboxkey 4s infinite;
      //     border-radius: 10px;
      //     margin-top: 80px;
      //     text-align: center;

      //     img {
      //       width: 360px;
      //       height: 270px;
      //       margin-top: 20px;
      //       //animation: imgbo 4s infinite;
      //     }
      //   }
      // }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }

  40% {
    border: solid rgb(255, 255, 255) 2px;
  }

  60% {
    border: solid rgb(255, 255, 255) 2px;
  }

  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }

  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }

  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {

  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }

  h3 {
    font-size: 30px;
  }

  p {
    font-size: 20px;
  }

  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: red;
  height: 3px;

  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}

.el-divider-active {
  background-color: #3c6088;
}

.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;

  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }
}
</style>